import dayjs from 'dayjs'

export const formatDate = (date, format = 'DD/MM/YYYY') => {
  return dayjs(date).format(format)
}

export const formatDatetime = (date, format = 'DD/MM/YYYY HH:mm') => {
  return dayjs(date).format(format)
}